import Vue from 'vue'
import BalmUI from 'balm-ui' // Mandatory
import BalmUIPlus from 'balm-ui/dist/balm-ui-plus' // Optional
import App from './views/app.vue'
import VueRouter from 'vue-router/dist/vue-router'
import VueVideoPlayer from 'vue-video-player'
import VueGtag from 'vue-gtag'
import 'video.js/dist/video-js.css'
import './registerServiceWorker'

import Landing from './views/landing'
import Presents from './views/presents'
import Changelog from './views/changelog'
import Privacy from './views/privacy'

Vue.use(BalmUI) // Mandatory
Vue.use(BalmUIPlus)
Vue.use(VueRouter)
Vue.use(VueVideoPlayer)
Vue.config.productionTip = false

const router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/landing',
      component: App,
      children: [
        {
          path: 'landing',
          component: Landing
        },
        {
          path: 'presents',
          component: Presents
        },
        {
          path: 'changelog',
          component: Changelog
        },
        {
          path: 'privacy',
          component: Privacy
        }
      ]
    }
  ]
})

Vue.use(VueGtag, {
  config: { id: 'G-X10FMJRXR9' }
}, router)

new Vue({
  router
}).$mount('#app')
